export default __webpack_public_path__ + "static/media/critical_thinking_active.cd4c8f4d.svg";